export default __webpack_public_path__ + "transfix-maps/icons/D1.e61a2afbcdf1672c55b4db148378d5a9.png";